import { lazy } from 'react';
import { Modal } from '@client/components/globals/Modal';
import { Loader } from '@client/components/common/Loader';
import type { GuestReservationProps } from '@client/components/Main/common/LoginModalProps.interface';

const GuestReservation = lazy(() => import('./GuestReservation'));

export const openGuestReservationModal = (props?: GuestReservationProps) => Modal.show({
  body: (
    <Loader
      load={GuestReservation}
      {...props}
    />
  ),
  buttons: [],
});
